<template>
  <div
    class="date-select"
    :class="{
      'is-invalid': invalid,
    }"
  >
    <div
      class="overlay"
      :class="{
        active: container,
      }"
      @click="closeContainer"
    ></div>

    <div class="c-input">
      <div class="hidden-label">Даты</div>

      <div class="c-input-wrapper">
        <div class="icon" @click="openContainer()">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
          </svg>
        </div>

        <div class="c-input-value" @click="openContainer">
          <div class="c-input-value-multiple">
            <div
              v-for="(selectValueItem, selectValueItemIndex) in selectValue"
              :key="selectValueItem.value"
              class="c-input-value-multiple-item"
            >
              <div class="c-input-value-multiple-item-text">
                {{ selectValueItem.label || getLabel(selectValueItem) }}
              </div>
              <div class="c-input-value-multiple-item-close">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  xmlns="http://www.w3.org/2000/svg"
                  @click="(e) => dropItem(e, selectValueItemIndex)"
                >
                  <path
                    d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
                  />
                  <path
                    d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div
          class="label"
          :class="{
            active: selectValue.length,
          }"
        >
          Даты
          <div class="label__info">
            <c-button
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: 'Даты',
                placement: 'bottom',
              }"
              size="iconic"
              icon="info"
            />
          </div>
        </div>
      </div>

      <div
        class="c-input-border"
        :class="{
          active: container,
        }"
      ></div>

      <div
        class="c-input-container"
        :class="{
          active: container,
        }"
      >
        <div class="c-input-container-date">
          <div class="lg">
            <datepicker
              ref="inputTypeDateDatepicker"
              :inline="true"
              :language="ru"
              :full-month-name="true"
              :disabled-dated="disabled"
              :monday-first="true"
              calendar-class="c-input-container-calendar"
              @selected="closeContainer"
              @input="selectDate($event, false)"
            />
          </div>
          <div class="sm">
            <div class="c-input-container-close" @click="container = false">
              <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
                  fill="#8E9CBB"
                />
                <path
                  d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
                  fill="#8E9CBB"
                />
              </svg>
            </div>
            <datepicker
              ref="inputTypeDateDatepicker"
              :inline="true"
              :language="ru"
              :full-month-name="true"
              :disabled-dated="disabled"
              :monday-first="true"
              calendar-class="c-input-container-calendar"
              @input="selectDate($event, 'temp')"
            />
            <div class="c-input-container__actions">
              <button type="button" class="c-input-container__action c-input-container__reset" @click="reset">
                Отменить
              </button>
              <button type="button" class="c-input-container__action c-input-container__apply" @click="apply">
                Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <error-feedback v-if="error" :text="error"></error-feedback>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";

import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

import { MONTHS_GEN } from "@/utils/date/months";

export default {
  name: "c-input",

  components: {
    Datepicker,
    CButton,
    ErrorFeedback,
  },

  props: ["value", "withYear", "invalid", "error"],

  data() {
    return {
      ru,
      selectValue: [],
      tempSelectValue: [],
      container: false,
    };
  },

  computed: {
    disabled() {
      return this.selectValue.map((v) => v.date);
    },
    format() {
      return this.withYear ? "DD.MM.YYYY" : "DD.MM";
    },
  },

  watch: {
    selectValue(value) {
      this.$emit("input", value);
    },

    value(value) {
      const formattedValue = this.formatValue(value);
      if (this.isEqualValues(this.selectValue, formattedValue)) return;
      this.selectValue = formattedValue;
    },
  },

  created() {
    this.selectValue = this.formatValue(this.value);
  },

  methods: {
    isEqualValues(value1, value2) {
      const str1 = value1.map((i) => i.value).toString();
      const str2 = value2.map((i) => i.value).toString();

      return str1 === str2;
    },
    openContainer() {
      this.tempSelectValue = [...this.selectValue];
      this.container = true;
    },

    closeContainer() {
      this.container = false;
    },

    getLabel(date) {
      const day = `${date.get("date")}`.padStart(2, "0");
      const month = MONTHS_GEN[date.get("month")];

      return `${day} ${month} ${this.withYear ? date.get("year") : ""}`;
    },

    selectDate(d, temp) {
      const date = moment(d);
      const formatted = date.format(this.format);

      let value = [];

      if (this.selectValue.some((v) => v.value === formatted)) {
        value = this.selectValue.filter((v) => v.value !== formatted);
      } else {
        value = [
          ...(this.selectValue || []),
          {
            date: date.format("DD.MM.YYYY"),
            value: formatted,
            label: this.getLabel(date),
          },
        ];
      }

      this.tempSelectValue = value;

      if (!temp) {
        this.selectValue = value;
        this.closeContainer();
      }
    },

    dropItem(e, index) {
      e.stopPropagation();
      this.selectValue.splice(index, 1);
    },

    reset() {
      this.closeContainer();
    },

    apply() {
      this.selectValue = [...this.tempSelectValue];
      this.closeContainer();
    },

    formatValue(value) {
      if (!value) return [];
      return value.map((item) => {
        if (typeof item === "string" || typeof item === "number") return this.formatDay(item.toString());
        return item;
      });
    },

    formatDay(d) {
      const [day, month, year] = d.split(".");
      d = `${day}.${month}.${year || new Date().getFullYear()}`;

      const date = moment(d, "DD.MM.YYYY");
      const formatted = date.format(this.format);
      return {
        date: d,
        value: formatted,
        label: this.getLabel(date),
      };
    },

    update(days) {
      this.selectValue = this.formatValue(days);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.date-select {
  .overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 450;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    &.active {
      visibility: visible;
      opacity: 1;

      @include onlyMobile {
        background: rgba(0, 0, 0, 0.7);
        transition: 0.3s;
      }
    }
  }

  .label {
    position: absolute;
    overflow: hidden !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    left: 0;
    font: 400 15px Fira Sans;
    line-height: 18px;
    color: $color-label;
    padding-bottom: 10px;
    transition: all 200ms;
    display: flex;
    align-items: center;

    &__info {
      display: none;
      margin-left: 4px;
    }

    &.active {
      font-size: 13px;
      transform: translate3d(0, -100%, 0);

      .label__info {
        display: inline-block;
      }
    }
  }

  .hidden-label {
    font-size: 12px;
    visibility: hidden;
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }

  .icon {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    order: 5;
    margin-left: 10px;
    margin-right: 0;

    svg {
      margin-bottom: 5px;
    }
  }
}

.c-input {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;

  &-wrapper {
    width: 100%;
    display: flex;
  }

  &-value {
    width: 100%;
    height: 30px;
    font-size: 15px;
    padding: 0 0 13px 0;
    cursor: pointer;
    order: 2;
    cursor: pointer;
    height: auto;
    min-height: 30px;
    padding-bottom: 0;
    width: 100%;
    max-width: 100%;

    &-multiple {
      display: flex;
      margin-top: -5px;
      margin-left: -5px;
      flex-wrap: wrap;
      max-width: calc(100% - 10px);

      &-item {
        display: inline-flex;
        align-items: center;
        white-space: nowrap;
        max-width: 90%;
        height: 30px;
        border: 1px solid $color-border;
        font: {
          size: 12px;
          weight: 500;
        }
        border-radius: 15px;
        padding: 0 14px;
        margin-left: 5px;
        margin-bottom: 5px;
        transition: 0.2s;

        &-text {
          max-width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: 500;
        }

        &-close {
          margin-left: 10px;
          // padding-top: 3px;

          svg {
            fill: $color-secondary;
            transition: 0.2s;
          }

          &:hover {
            svg {
              fill: $color-secondary-hover;
            }
          }
        }

        &:hover {
          border-color: $color-button-border-hover;
        }
      }
    }
  }

  &-border {
    height: 1px;
    width: 100%;
    position: absolute;
    background: $color-control-border;
    bottom: 0;
    transition: 0.2s;

    &.active {
      background: $color-primary;
    }
  }

  &-container {
    position: absolute;
    background: #ffffff;
    box-shadow: $box-shadow-container;
    border-radius: $border-radius-container;
    z-index: 451;
    top: 50px;
    width: 100%;
    box-sizing: border-box;
    transition: 0.2s;
    opacity: 0;
    visibility: hidden;
    padding: 5px 10px 10px 10px;

    width: auto;
    padding: 10px !important;

    &-close {
      display: block;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 2;
    }

    &.active {
      top: 100%;
      opacity: 1;
      visibility: visible;

      margin-top: 10px;
      right: 0;
    }

    @include onlyMobile {
      position: fixed;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      padding: 20px 15px 0px !important;
      transition: none;
      border-radius: 0;

      &__actions {
        margin-left: -15px;
        margin-right: -15px;
        margin-top: 8px;
        display: flex;
      }
      &__action {
        width: 100%;
        height: 38px;
        border: none;
        background: transparent;
        outline: none;
        font-size: 15px;
        font-weight: 500;
      }
      &__apply {
        background: $color-primary;
        color: white;
      }
      &__reset {
        border-top: 1px solid #d3d8df;
        color: black;
      }

      &.active {
        margin-top: 0;
        top: 0%;
        left: 0%;

        /deep/ {
          .c-input-container-calendar {
            margin: 0 auto;

            .day {
              border-radius: 17px;
            }

            .day,
            .day-header {
              height: 34px !important;
            }
          }
        }
      }
    }
  }

  .is-invalid &,
  &.is-invalid {
    .c-input-border {
      background: $color-error;
    }
  }

  .sm {
    display: none;
  }

  @include onlyMobile {
    .sm {
      display: block;
    }
    .lg {
      display: none;
    }
  }
}
</style>
